<p-dialog header="Edit your comment" [(visible)]="bookingService.activeInternalBookingCommentEdit" [modal]="true">
    <app-edit-internal-booking-comment *ngIf="bookingService.internalCommentForm"></app-edit-internal-booking-comment>
</p-dialog>
<div class="summary-container" [formGroup]="bookingService.bookingForm">
    <div class="student-information-box">
        <div class="title-container">
            <h3 class="title">
                Student Information
            </h3>
        </div>
        <div class="booking-student-information-container">
            <table>
                <colgroup>
                    <col span="1" width="140">
                    <col span="1" width="180">
                </colgroup>
                <tr>
                    <td>
                        <p>Last name:</p>
                    </td>
                    <td>
                        <p>{{bookingService.booking.student.lastName}}</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>First name:</p>
                    </td>
                    <td>{{bookingService.booking.student.firstName}}</td>
                </tr>
                <tr>
                    <td>
                        <p>Gender</p>
                    </td>
                    <td>
                        <p *ngIf="bookingService.booking.student.gender">
                            {{bookingService.booking.student.gender.name | titlecase}}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        Country
                    </td>
                    <td>
                        <p *ngIf="bookingService.booking.student.country">
                            {{bookingService.booking.student.country.name}}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        Date of birth
                    </td>
                    <td>
                        <p *ngIf="bookingService.booking.student.birthDay">
                            {{bookingService.booking.student.birthDay!.toDate() | date:'dd/MM/yyyy'}}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        Age at departure
                    </td>
                    <td>
                        <p *ngIf="bookingService.booking.ageAtStartDate">
                            {{bookingService.booking.ageAtStartDate}}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>Language level:</td>
                    <p-dropdown optionLabel="name" [options]="bookingService.targetLanguageLevels"
                        formControlName="targetLanguageLevel"></p-dropdown>
                </tr>
            </table>
        </div>
    </div>
    <div class="accommodation-box" *ngIf="bookingService.booking.accommodation">
        <div class="title-container">
            <h3 class="title">
                Accommodation
            </h3>
        </div>
        <div class="booking-student-information-container">
            <table>
                <colgroup>
                    <col span="1" width="140">
                    <col span="1" width="180">
                </colgroup>
                <tr>
                    <td>
                        Type:
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.accommodationType.name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Room:
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.roomType.name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Board:
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.boardType.name}}
                    </td>
                </tr>
                <tr *ngIf="bookingService.booking.accommodation.accommodationType.id == 2">
                    <td>
                        Last name:
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.hostLastName}}
                    </td>
                </tr>
                <tr *ngIf="bookingService.booking.accommodation.accommodationType.id == 2">
                    <td>
                        First name:
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.hostFirstName}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Address:
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.address}}
                    </td>
                </tr>
                <tr>
                    <td>
                        City:
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.postCode}} {{bookingService.booking.accommodation.city}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Email:
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.email}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Phone:
                    </td>
                    <td>
                        {{bookingService.booking.accommodation.phoneNumber}}
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="programme-information-box">
        <div class="title-container">
            <h3 class="title">
                Programme Information
            </h3>
        </div>
        <div class="programme-information-container">
            <div class="start-date-box">
                <p>
                    Start Date
                </p>
                <p-calendar *ngIf="userService.hasAnyRole(['admin', 'editor'])" [monthNavigator]="true"
                    (onSelect)="bookingService.calculateAgeAtStartDate()" [yearRange]="bookingService.yearRange"
                    [yearNavigator]="true" formControlName="startDate" dateFormat="dd/mm/yy" [showIcon]="true" [inputStyle]="{'width':'172px'}"></p-calendar>
                <input *ngIf="userService.isNotAnyOf(['admin', 'editor'])" pInputText
                    [value]="bookingService.booking.startDate.format('DD/MM/YYYY')" readonly>
            </div>
            <div class="end-date-box">
                <p>
                    End Date
                </p>
                <p-calendar *ngIf="userService.hasAnyRole(['admin', 'editor'])" [monthNavigator]="true"
                    [yearRange]="bookingService.yearRange" [yearNavigator]="true" formControlName="endDate"
                    dateFormat="dd/mm/yy" [showIcon]="true" [inputStyle]="{'width':'172px'}"></p-calendar>
                <input *ngIf="userService.isNotAnyOf(['admin', 'editor'])" pInputText
                    [value]="bookingService.booking.endDate.format('DD/MM/YYYY')" readonly>
            </div>
            <div class="destination-box">
                <p>Destination</p>
                <p-dropdown *ngIf="userService.hasAnyRole(['admin', 'editor'])" formControlName="destination"
                    dataKey="id" [options]="bookingService.countryList" optionLabel="name"
                    (onChange)="updateSchools($event.value)" [style]="{'width': '210.98px'}" [filter]="true" filterBy="name">
                </p-dropdown>
                <input *ngIf="userService.isNotAnyOf(['admin', 'editor']) && bookingService.booking.destination"
                    pInputText [value]="bookingService.booking.destination.name" readonly>
            </div>
            <div class="school-box">
                <p>School</p>
                <p-dropdown *ngIf="userService.hasAnyRole(['admin', 'editor'])" formControlName="school" dataKey="id"
                    placeholder="Select School" [options]="bookingService.schoolList" [filter]="true" filterBy="name" optionLabel="name"
                    [style]="{'width': '210.98px'}"
                    (onChange)="updateLanguageCourses($event.value);updateProgrammeTypes($event.value);updateProgrammeInformationList($event.value);updateGoogleSheetUrl($event.value)">
                </p-dropdown>
                <input *ngIf="userService.isNotAnyOf(['admin', 'editor']) && bookingService.booking.school" pInputText
                    [value]="bookingService.booking.school.name" readonly>
            </div>
            <div class="programme-type-box">
                <p>Programme Type</p>
                <p-dropdown *ngIf="userService.hasAnyRole(['admin', 'editor'])" formControlName="programmeType"
                    dataKey="id" placeholder="Select Programme type" [options]="bookingService.programmeTypes"
                    optionLabel="name" [style]="{'width': '210.98px'}">
                </p-dropdown>
                <input *ngIf="userService.isNotAnyOf(['admin', 'editor']) && bookingService.booking.programmeType"
                    pInputText [value]="bookingService.booking.programmeType.name" readonly>
            </div>
            <div class="course-box">
                <p>Course</p>
                <p-dropdown *ngIf="userService.hasAnyRole(['admin', 'editor'])" placeholder="Course" dataKey="id"
                    formControlName="languageCourse" [options]="bookingService.languageCourseList" optionLabel="code"
                    [style]="{'width': '100%'}" (onChange)="languageCourseChange($event.value)">
                    <ng-template let-course pTemplate="item">
                        {{course.code}}: {{course.descriptionFr}}
                    </ng-template>
                    <ng-template pTemplate="selectedItem">
                        {{bookingService.bookingForm.value.languageCourse.code}}: {{bookingService.bookingForm.value.languageCourse.descriptionFr}}
                    </ng-template>
                </p-dropdown>
                <input *ngIf="userService.isNotAnyOf(['admin', 'editor']) && bookingService.booking.languageCourse"
                    pInputText [value]="bookingService.booking.languageCourse!.code" readonly>
                <p *ngIf="courseDescriptionHasNoTranslation" class="warning">⚠️This course has no translated description
                    in {{bookingService.booking.student.language.name}}.
                    <a routerLink="/management/edit-school/{{bookingService.bookingForm.value.school?.id}}">Edit</a>
                </p>
            </div>
            <div class="course-remarks-box">
                <p>
                    Course Remarks
                </p>
                <textarea pInputTextArea formControlName="courseComment" class="course-comment"></textarea>
            </div>
            <div class="meeting-time-box">
                <p>
                    Schedule Meeting
                </p>
                <p-calendar [defaultDate]="bookingService.defaultDateTime" [yearRange]="bookingService.yearRange"
                    [yearNavigator]="true" dateFormat="dd/mm/yy at" [showTime]="true" [stepMinute]="10"
                    formControlName="highSchoolMeetingDate" [showIcon]="true" [monthNavigator]="true"></p-calendar>
            </div>
            <div class="test-score-box">
                <p>
                    Test Score
                </p>
                <input pInputText formControlName="highSchoolTestScore" class="test-score-input">
            </div>
            <div class="duration-box">
                <p>Duration (weeks)</p>
                <input pInputText [value]="bookingService.booking.duration" readonly class="duration-input">
            </div>

            <div class="excursion-date-box">
                <p>
                    Excursion Date
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="excursionDate" [showIcon]="true" [monthNavigator]="true"></p-calendar>
            </div>
            <div class="activities-remarks-box">
                <p>
                    Activities Remarks
                </p>
                <textarea pInputTextArea formControlName="activitiesComment" class="activities-comment"></textarea>
            </div>
            <div class="promo-code-box">
                <p>
                    Promo Code
                </p>
                <input pInputText formControlName="promoCode" class="promo-code-input">
            </div>
            <div>
                <div class="checkbox-container">
                    <p-checkbox [binary]="true" formControlName="cancellationInsuranceRequested"
                        (onChange)="updateCancellationInsuranceSuppliers()"></p-checkbox>
                    <p>
                        Cancellation Insurance
                    </p>
                </div>
                <div *ngIf="bookingService.bookingForm.get('cancellationInsuranceRequested')!.value"
                    class="insurance-supplier-container">
                    <p-dropdown placeholder="select" optionLabel="name" [style]="{'width': '100%'}"
                        [options]="bookingService.cancellationInsuranceSuppliers"
                        formControlName="cancellationInsuranceSupplier"></p-dropdown>
                </div>
            </div>
            <div>
                <div class="checkbox-container">
                    <p-checkbox [binary]="true" formControlName="travelInsuranceRequested"
                        (onChange)="updateTravelInsuranceSuppliers()"></p-checkbox>
                    <p>
                        Travel Insurance
                    </p>
                </div>
                <div *ngIf="bookingService.bookingForm.get('travelInsuranceRequested')!.value"
                    class="insurance-supplier-container">
                    <p-dropdown placeholder="select" optionLabel="name" [style]="{'width': '100%'}"
                        [options]="bookingService.travelInsuranceSuppliers" formControlName="travelInsuranceSupplier">
                    </p-dropdown>
                </div>
            </div>
            <div>
                <div class="checkbox-container">
                    <p-checkbox [binary]="true" formControlName="flightRequested"></p-checkbox>
                    <p>
                        Flight Requested
                    </p>
                </div>
                <div class="checkbox-container-with-partena">
                    <p-checkbox [binary]="true" formControlName="withPartena"></p-checkbox>
                    <p>
                        With Partena
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="key-date-container">
        <div class="title-container">
            <h3 class="title">
                Booking Status
            </h3>
        </div>
        <div class="key-date-flex-container">
            <div class="input-box">
                <p>
                    Pre-confirmation Sent
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="preConfirmationSent" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Deposit Received
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="depositReceived" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Sent to School
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="sentToSchool" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}">
                </p-calendar>
            </div>
            <div class="input-box">
                <p>
                    School Confirmation
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="schoolConfirmed" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Booking Confirmation
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="bookingConfirmed" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Fully Paid
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="completePaymentReceived" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Accommodation Sent
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="accommodationSent" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Travel Info Sent
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="travelInformationSent" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Final Confirmation
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="finalConfirmationSent" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box"
                *ngIf="bookingService.bookingForm.get('programmeType')!.value && bookingService.bookingForm.get('programmeType')!.value.id == 2">
                <p>
                    Flight Booked
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="flightBookedDate" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Visa Information Sent
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="visaInformationSent" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Travel Insurance Sent
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                    formControlName="insuranceSent" [showIcon]="true" [monthNavigator]="true"
                    [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Cancellation subscribed
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                formControlName="cancellationInsuranceSubscriptionDate" [showIcon]="true" [monthNavigator]="true"
                [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
            <div class="input-box">
                <p>
                    Reminder date
                </p>
                <p-calendar [yearRange]="bookingService.yearRange" [yearNavigator]="true" dateFormat="dd/mm/yy"
                formControlName="reminderDate" [showIcon]="true" [monthNavigator]="true"
                [inputStyle]="{'width':'120px'}"></p-calendar>
            </div>
        </div>
    </div>
    <div class="travel-table-container">
        <div>
            <div>
                <div>
                    <h3 class="title">
                        Travel Information
                    </h3>
                </div>
            </div>
            <div>
                <table class="travel-table">
                    <colgroup>
                        <col class="type-col">
                        <col class="transport-type-col">
                        <col class="flight-number-col">
                        <col class="departure-airport-col">
                        <col class="departure-date-col">
                        <col class="departure-time-col">
                        <col class="arrival-airport-col">
                        <col class="arrival-date-col">
                        <col class="arrival-time-col">
                        <col span="1">
                    </colgroup>
                    <tr>
                        <th colspan="2">
                            Travel Type
                        </th>
                        <th>
                            Reference
                        </th>
                        <th colspan="3">
                            Departure
                        </th>
                        <th colspan="3">
                            Arrival
                        </th>
                    </tr>
                    <tr>
                        <th>Trip</th>
                        <th>Vehicle</th>
                        <th class="travel-id-header">
                            <span class="travel-id-text">Travel ID </span>
                            <i [pTooltip]="bookingSummaryService.travelIdLongText" tooltipPosition="right"
                                class="pi pi-question-circle" style="font-size: 16px"></i>
                        </th>
                        <th>Location</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Location</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th></th>
                    </tr>
                    <tr *ngFor="let travel of bookingService.travelForms.controls; let i = index" class="travel-form">
                        <td [formGroup]="travel | formGroup">
                            <p-dropdown placeholder="SELECT" dataKey="id" [options]="bookingService.travelTypes"
                                optionLabel="name" formControlName="travelType"
                                [style]="{'width':'120px','min-width':'120px'}">
                            </p-dropdown>
                        </td>
                        <td [formGroup]="travel | formGroup">
                            <p-dropdown [options]="bookingService.transportTypes" optionLabel="name"
                                [style]="{'width':'100px','min-width':'100px'}" formControlName="transportType">
                            </p-dropdown>
                        </td>
                        <td [formGroup]="travel | formGroup">
                            <input pInputText formControlName="flightNumber" class="flight-number-input">
                        </td>
                        <td [formGroup]="travel | formGroup">
                            <input pInputText formControlName="departureAirport" class="airport-input">
                        </td>
                        <td [formGroup]="travel | formGroup">
                            <p-calendar [inputStyle]="{'width':'110px'}" [monthNavigator]="true"
                                [yearRange]="bookingService.yearRange" [yearNavigator]="true"
                                formControlName="departureDate" dateFormat="dd/mm/yy"></p-calendar>
                        </td>
                        <td [formGroup]="travel | formGroup">
                            <p-calendar [inputStyle]="{'width':'110px'}" [timeOnly]="true"
                                formControlName="departureTime">
                            </p-calendar>
                        </td>
                        <td [formGroup]="travel | formGroup">
                            <input pInputText formControlName="arrivalAirport" class="arrival-airport-input">
                        </td>
                        <td [formGroup]="travel | formGroup">
                            <p-calendar [inputStyle]="{'width':'110px'}" [monthNavigator]="true"
                                [yearRange]="bookingService.yearRange" [yearNavigator]="true"
                                formControlName="arrivalDate" dateFormat="dd/mm/yy"></p-calendar>
                        </td>
                        <td [formGroup]="travel | formGroup">
                            <p-calendar [inputStyle]="{'width':'110px'}" [timeOnly]="true"
                                formControlName="arrivalTime">
                            </p-calendar>
                        </td>
                        <td>
                            <p-button icon="pi pi-trash" (onClick)="bookingSummaryService.deleteTravel(travel, i)"
                                styleClass="p-button-danger">
                            </p-button>
                        </td>
                    </tr>
                </table>
                <div class="travel-add-button-container">
                    <p-button icon="pi pi-plus" label="Add travel" (onClick)="bookingSummaryService.addTravelForm()"
                        *ngIf="userService.hasAnyRole(['admin', 'editor'])"></p-button>
                </div>
                <div class="travel-code-transfer-container">
                    <div>
                        <p>
                            Code
                        </p>
                        <p-dropdown placeholder="x" [options]="bookingService.travelRequestCodes"
                            formControlName="travelRequestCode"></p-dropdown>
                    </div>
                    <div>
                        <p>
                            Transfer from/to Airport
                        </p>
                        <p-dropdown dataKey="id" placeholder="Select Transfer option" optionLabel="name"
                            [options]="bookingService.transferTypes" formControlName="transferType"></p-dropdown>
                    </div>
                    <div class="emergency-transfer-contact-container">
                        <div>
                            <p>
                                Emergency Phone
                            </p>
                            <input placeholder="+32 XXX XXXX" pInputText formControlName="emergencyTransferPhoneNumber">
                        </div>
                        <div>
                            <p>
                                Emergency info
                            </p>
                            <input placeholder="/" pInputText formControlName="emergencyTransferContact" [style]="{'width': '280px'}">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-left-container">
        <div class="comments-container">
            <div class="title-container">
                <h3 class="title">
                    Internal Comments
                </h3>
            </div>
            <div class="new-internal-comment-container">
                <textarea placeholder="New comment to add" formControlName="internalComment" pInputTextarea
                    class="new-comment-textarea"></textarea>
                <div class="comment-post-button-container">
                    <p-button label="Post" (onClick)="bookingSummaryService.postInternalComment()"></p-button>
                </div>
            </div>
            <div class="internal-comments-container">
                <div *ngFor="let comment of bookingService.booking.internalCommentList" class="internal-comment-box">
                    <div class="internal-comment-body">
                        {{comment.body}}
                    </div>
                    <div class="internal-comment-options-container">
                        <span class="internal-comment-detail">
                            {{comment.createdBy!.name}} at {{comment.created | date:"dd/MM/yyyy HH:mm"}}
                            <span *ngIf="comment.isModified">
                                (edited)
                            </span>
                        </span>
                        <span *ngIf="comment.createdBy!.name == userService.userName">
                            <a (click)="bookingService.activateInternalCommentEditDialog(comment)">
                                Edit
                            </a>
                            -
                            <a (click)="deleteComment(comment)">
                                Delete
                            </a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-right-container">
        <div class="school-comment-container">
            <div class="title-container">
                <h3 class="title">
                    Comments transferred to school
                </h3>
            </div>
            <div class="school-comment-box">
                <textarea *ngIf="userService.hasAnyRole(['admin', 'editor'])" formControlName="commentToSchool"
                    class="comment-to-school" pInputTextarea></textarea>
                <input *ngIf="userService.isNotAnyOf(['admin', 'editor'])" [value]="bookingService.booking.commentToSchool"
                    class="comment-to-school" readonly>
            </div>
        </div>
        <div class="booking-request-comment-container" *ngIf="bookingService.bookingRequestComment">
            <h3 class="title">
                General remarks
            </h3>
            <div class="booking-request-comment-wrap">
                <p>
                    {{bookingService.bookingRequestComment}}
                </p>
            </div>
        </div>
        <div class="email-history-items-container" *ngIf="bookingService.emailHistories.length > 0">
            <div class="title-container">
                <h3 class="title">
                    Sent email history
                </h3>
            </div>
            <div *ngFor="let history of bookingService.emailHistories" class="email-history-card-container">
                <div class="email-history-card">
                    <div>
                        <span class="email-type-label">
                            {{history.type.label | titlecase}}
                        </span>
                    </div>
                    <div>
                        <p>
                            Sent : {{history.email.sentDateTime?.toDate() | date:'dd/MM/yyyy - HH:mm'}}
                        </p>
                    </div>
                    <div class="p-button-tag-container">
                        <p-button label="VIEW E-MAIL" (onClick)="activateEmailHistoryDetail(history)"></p-button>
                            <p-chip *ngIf="history.email.isOpened" label="Seen on: {{history.email.openedAt?.toDate() | date:'dd/MM/yyyy - HH:mm'}}"
                             [style]="{'background-color': 'rgb(13, 167, 15)', 'color': 'white'}"></p-chip>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>